<template>
  <div>
    <div class="css-grid battery-order-form__row">
      <div class="h-collapsible"></div>
      <div>
        <div class="grid__col--6">
          <label class="form__label">Card Number:</label>
          <div id="cardNumberContainer"></div>
        </div>
        <div class="grid__col--4">
          <label class="form__label">Expiration Date:</label>
          <div id="expirationDateContainer"></div>
        </div>
        <div class="grid__col--2">
          <label class="form__label">Sec Code:</label>
          <div id="securityCodeContainer"></div>
        </div>
      </div>
      <div class="h-collapsible"></div>
    </div>
    
  </div>
</template>

<script>
  import StoreConnectedSelect from '../../form-items/StoreConnectedSelect.vue';
  import StoreConnectedInput from '../../form-items/StoreConnectedInput.vue'
  import { mapGetters } from 'vuex'

  export default {
    name: 'CreditCardForm',
    components: {
      StoreConnectedInput,
      StoreConnectedSelect,
    },
    data() {
      return {
        store: 'payInvoice',
        action: 'setObjectProperty',
      };
    },
    computed: {
      ...mapGetters('batteryStore', ['states']),
      //...mapGetters('payInvoice', ['gravityAssetsUrl']),
    },
  };
</script>
